import React from "react";
import Typography from "components/Typography";
import Button from "components/Button";
import classes from "./GoodsamInsuranceModalFooter.module.css";
import cn from 'classnames';

export const GoodsamInsuranceModalFooter = (props) => {
  const {
    isDisabled,
    onSelectPlan,
    onClose
  } = props;


  return (
    <div className={classes.container}>
      <div className={classes.containerInner}>
        <div className={classes.buttons}>
          <Button
            onClick={onClose}
            secondary
            className={classes.buttonCancel}
          >
            Cancel
          </Button>
          <Button
            disabled={isDisabled}
            onClick={onSelectPlan}
          >
            Confirm
          </Button>
        </div>
      </div>
    </div>
  );
};
